import React from 'react';
import moment from 'moment';
import { Box, Flex, Text, Icon } from '@chakra-ui/react';
import { priceUsd } from 'utils/utility';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const RecentBids = ({ bids }) => {
  const [more, setMore] = React.useState(false);

  return (
    <Flex id="recent_bids" flexDirection="column" mb="10px">
      <Text fontWeight="bold" mb="20px">
        Recent Bids
      </Text>
      <Box bg="white" boxShadow="0 0 4px 0 rgba(0, 0, 0, 0.08)" mb="20px" borderRadius={4} fontSize="12px">
        <Flex id="table_header" color="#3a3a3a" borderBottomWidth={1} p="6px 15px">
          <Flex flex="2">Price</Flex>
          <Flex flex="2">Date</Flex>
          <Flex flex="1">Bidder</Flex>
        </Flex>
        {more ? (
          bids.map((i, idx) => {
            return (
              <Flex key={i.id} color="#161616" borderBottomWidth={1} p="9px 15px" fontWeight="medium">
                <Flex flex="2">{priceUsd(i.amount / 100)}</Flex>
                <Flex flex="2">{i.created_at ? moment(i.created_at).format('MM/DD/YYYY [at] h:mma z') : ''}</Flex>
                <Flex flex="1">{idx === 0 && `@${i.user?.username}`}</Flex>
              </Flex>
            );
          })
        ) : (
          <Flex id="table_content" color="#161616" borderBottomWidth={1} p="9px 15px" fontWeight="medium">
            <Flex flex="2">{priceUsd(bids[0]?.amount / 100)}</Flex>
            <Flex flex="2">
              {bids[0]?.created_at ? moment(bids[0]?.created_at).format('MM/DD/YYYY [at] h:mma z') : ''}
            </Flex>
            <Flex flex="1">{`@${bids[0]?.user?.username}`}</Flex>
          </Flex>
        )}

        <Flex
          color="#0079ff"
          p="6px 15px"
          alignItems="center"
          justifyContent="center"
          fontWeight="medium"
          cursor="pointer"
          onClick={() => setMore(more ? false : true)}
        >
          {more ? (
            <>
              <Icon as={FiChevronUp} /> Show less
            </>
          ) : (
            <>
              <Icon as={FiChevronDown} /> Show more
            </>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};
export default RecentBids;
